import { render, staticRenderFns } from "./ComponentRegisterSuccess.vue?vue&type=template&id=06b9f67d&scoped=true&"
import script from "./ComponentRegisterSuccess.vue?vue&type=script&lang=js&"
export * from "./ComponentRegisterSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ComponentRegisterSuccess.vue?vue&type=style&index=0&id=06b9f67d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b9f67d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
